import React, {useState, useContext, useEffect} from 'react';
import {IdTariff} from "../contexts/HomeContext";
import FourteenImg from "../images/14.png";


const TariffCard = (props) => {
    const {tariffId, setTariffId} = useContext(IdTariff);
    const [externalBlockStyle, setExternalBlockStyle] = useState({});
    const [stickerBottomStyle, setStickerBottomStyle] = useState({});
    const [stickerTopStyle, setStickerTopStyle] = useState({});
    const [fourteenImgStyle, setFourteenImgStyle] = useState({});
   
    const chooseTariff = () => {
        if (props.tariff.active === true){
            setTariffId(props.tariff.id);
        }
    }

    useEffect(() => {
        if (props.tariff.popular === true){
            setTariffId(props.tariff.id);
            setStickerTopStyle({});
        }else{
            setStickerTopStyle({display:'none'});
        }
        if (props.tariff.active === true){
            setFourteenImgStyle({display:'none'})
        }else {
            setFourteenImgStyle({})
        }
    },[]);


    useEffect(() =>{
        if (tariffId === props.tariff.id){
            setExternalBlockStyle({border:'1px solid #FFFFFF'});
            setStickerBottomStyle({});
        }else{
            setExternalBlockStyle({});
            setStickerBottomStyle({display:'none'});
        }
    }, [tariffId]);


    return (
        <div className='tariff_card'>
            <div style={externalBlockStyle} className='external_block'>
                   <div onClick={chooseTariff} className='internal_block'>
                   <div style={stickerTopStyle} className='sticker_top'>Самый популярный</div>
                        <div className='term'>
                            <span>{props.tariff.numberOfDays} ДНЕЙ</span>
                            <img style={fourteenImgStyle} alt='#' className="fourteen_img" src={FourteenImg}/>
                        </div>
                            <span>{props.tariff.price}₽</span>
                   </div>
                   <div style={stickerBottomStyle} className='sticker_bottom'>Выбран</div>
            </div>
        </div>
    );
};

export default TariffCard;